import { kipPerFtSplit } from '../units/units.js'

export function PointLoad(x, D, isMoment ) {
  this.x = x // inches
  this.D = D // lbs or in-lbs
  this.isMoment = isMoment
}

PointLoad.prototype.direction = function() {
  if(this.D < 0) return "up"
  return "down"
}

PointLoad.prototype.Label = function(unit) {
  let label = ""
  let factor = 1;
  if( this.isMoment && unit.match(/^(k|kip|kips)(-|.|(s\{0,}))(ft|feet|foot)$/)) {
    factor = 0.001/12
    unit = " k-ft"
  } else if(unit.match(/^(k|kip|kips)$/)) {
    factor = 0.001
    unit = " k"
  }
  if( this.D != 0 ) {
    label = `D = ${(this.D * factor).toFixed(2)} ${unit}`
  }
  return label;
}

export function DistLoad(x1, x2, D, D2, isLinear) {
  this.x1 = x1; // inches
  this.x2 = x2; // inches
  this.D = D; // lbs/in
  this.isLinear = isLinear;
  this.D2 = D2; // lbs/in
}

DistLoad.prototype.direction = function() {
  if(this.D < 0) return "up";
  return "down";
}

DistLoad.prototype.Label = function(unit) {
  var label = "";
  var factor = 1;
  if(unit.match(kipPerFtSplit)){
      factor = 0.001*12;
      unit = " k/ft";
  }
  if( this.D != 0 || (this.isLinear && this.D != this.D2) ) label += "D = " + (this.D*factor).toFixed(2) + unit;
  if( this.isLinear && (this.D != this.D2) ) label += " to " + (this.D2*factor).toFixed(2) + unit;
  return label;
}

DistLoad.prototype.Length = function() {
  return Math.abs(this.x1 - this.x2);
}

DistLoad.prototype.Overlaps = function(b) {
  return ( (b.x1 >= this.x1 && b.x1 < this.x2 ) ||
          (b.x2 > this.x1 && b.x2 < this.x2 ) ||
          (b.x1 == this.x1 && b.x2 == this.x2) ||
          (b.x1 == this.x2 && b.x2 == this.x1) );
}